export default __webpack_public_path__ + "static/media/line5.23b80c78.svg";